import tw from 'tailwind-styled-components'
import {TwRadioButtonType} from './types'

const dotMixin = `
  after:content-[""]
  after:absolute
  after:w-6
  after:h-6
  after:top-1/2
  after:left-1/2
  after:transform
  after:-translate-x-1/2
  after:-translate-y-1/2
  after:rounded-full
`

export const TwRadioButton = tw.div<TwRadioButtonType>`
  relative
  rounded-full
  w-16
  h-16
  ${p => {
    const cx: string[] = []
    if (p.$disabled && p.$active) {
      cx.push('bg-action-disabled', dotMixin, 'after:bg-icon-invert')
    } else if (p.$disabled) {
      cx.push(
        'shadow-border-1',
        'shadow-action-disabled',
        'bg-background-disabled'
      )
    } else if (p.$active) {
      cx.push(
        'cursor-pointer',
        'bg-action-default',
        'group-hover/radiobutton:bg-action-hover',
        'group-active/radiobutton:bg-action-pressed',
        dotMixin,
        'after:bg-icon-invert'
      )
    } else {
      cx.push(
        'cursor-pointer',
        'shadow-border-1',
        p.$error ? 'shadow-status-error' : 'shadow-line-base',
        'group-hover/radiobutton::shadow-line-hover',
        'group-active/radiobutton:shadow-line-pressed',
        'bg-background-primary'
      )
    }
    return cx.join(' ')
  }}
`
